module.exports = __webpack_public_path__ + "static/ui-0dddca151251ea691515694183a1a120.svg";